<template>
    <div v-bind:class="{'effect-moveIn' : item.addedToCart, 'effect-moveOut' : item.removed }" class="basket-item-container col-12">
        <div class="row cart-item-header cart-item-discount-header" v-if="item.redeemedRewardQuantity >0 || (item.appliedDiscounts && item.appliedDiscounts.length)">
            <span class="col-12" v-for='discount in item.appliedDiscounts'>
                <span>
                    <span class="font-weight-bold"><span v-if="item.appliedDiscounts.length >1">{{discount.appliedDiscountQty}}</span> {{discount.name}}</span>
                    <span class="color-primary d-block">{{discount.description}}</span>
                </span>
            </span>
            <span v-if="item.redeemedRewardQuantity >0" class=" col-12 color-primary font-secondary">{{item.redeemedRewardQuantity}} <span v-if="item.redeemedRewardQuantity != 1"><translate item="freeProductPlural" fallback="gratis broodjes | spaaractie" /> </span> <span v-if="item.rewardProductsCount==1"><translate item="freeProduct" fallback="gratis broodje | spaaractie" /></span> </span>
        </div>


        <div class="row">

            <div class="quantity col-6">
                <amz-spinner v-model="item.quantity" v-on:quantitychange="quantityChanged" v-bind:name="'itemquantity' + item.id">
                </amz-spinner>
            </div>

            <div class="remove subtotal text-right col-6" v-if="item.discount && item.discount.priceInclTax >0">
                <span class="product-subtotal text-nowrap discounted">{{(dishTotal + item.discount.priceInclTax) | toCurrency}}</span>
                <input type="checkbox" class="d-none" name="removefromcart" v-bind:value="item.id" />
                <span class="icon-trash removefromcart" v-on:click="removeCartItem"></span>
                <div class="product-discount text-nowrap">
                    <span>{{dishTotal | toCurrency }}</span>
                </div>
            </div>


            <div class="remove subtotal text-right col-6" v-else>
                <span class="product-subtotal text-nowrap">{{dishTotal | toCurrency}}</span>
                <input type="checkbox" class="d-none" name="removefromcart" v-bind:value="item.id" />
                <span class="icon-trash removefromcart" v-on:click="removeCartItem"></span>
            </div>

        </div>
        <div class="row">
            <div class="product-name col-12">
                <span class="text-nowrap">{{item.product.content.productName}}</span>

                <div v-if="item.product.compositeProducts">
                    <span v-for="(child,index) in item.product.compositeProducts" class="composite-cart text-nowrap">
                        {{child.content.productName}}
                    </span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 additional">
                <span v-for="(child,index) in item.children" class="preparation-method-cart prep-id">
                    <span v-if="index > 0">, </span><span v-if="child.quantity / item.quantity>1">{{child.quantity / item.quantity}}x </span><span>{{child.product.content.productName}}</span>

                    <span v-for="(child2,index2) in child.children" class="preparation-method-cart prep-id">
                        <span v-if="index2 > 0">, </span><span v-if="child2.quantity / item.quantity>1">{{child2.quantity / item.quantity }}x </span><span>{{child2.product.content.productName}}</span>
                    </span>

                </span>
            </div>
        </div>

        <div class="row product-ingredient-info" v-if="item.product.content.allergenen">
            <div class="col-12">

                <span v-if="!item.product.content.allergenen.length"><translate item="CartNoAllergies" fallback="Geen allergenen informatie" /></span>
                <template v-else>
                    <span><translate item="CartContains" /></span>
                    <span v-for="allergyId in item.product.content.allergenen" v-bind:key="allergyId" class="allergy-icon" :class="getAllergy('id' + allergyId).fontIcon">{{getAllergy('id'+allergyId).title}}</span>
                </template>

            </div>
        </div>
    </div>
</template>

<script>

    import { services } from '../Services/Services'
    import shoppingCartService from '../Services/ShopingCartService';
    import amzSpinner from './amz-spinner.vue';
    import translate from './translate';

    export default {

        props: { "item": Object },
        components: { amzSpinner, translate },
        methods: {
            /**
             * Returns the allergy, used to display the icon + name
             * @param {number} id - the allergy Id
             * @returns {object} - the requested allergy
             */
            getAllergy: function (id) {
                return services.getAllergy(id);
            },

            /**
             * Click handler for the remove cartitem button
             **/
            removeCartItem: function () {
                // raise event, amz-cart component is responsible for api interaction
                this.$emit('remove-cart-item', { item: this.item, el: this.$el });
            },

            /**
             * Quantity changed handler
             * @param {decimal} q - the quantity
             */
            quantityChanged: function (event) {
                this.$emit('cart-item-quantitychanged', { item: this.item, oldQ: event.oldValue, el: this.$el });
            }

        },
        computed: {
            /** Returns the total of the dish
             * @return {number} - the total of the dish
             **/
            dishTotal: function () {

                var total = this.item.subTotal.priceInclTax;

                for (var i in this.item.children) {
                    let child = this.item.children[i];
                    total += child.subTotal.priceInclTax;
                    if (child.children) {
                        for (var i2 in child.children) {
                            let grchild = child.children[i2];
                            total += grchild.subTotal.priceInclTax;
                        }
                    }
                }
                return total;
            },

            rewardProductsCount : function() {
                return this.item.redeemedRewardQuantity;
            }

        }
    }


</script>



// WEBPACK FOOTER //
// Vue/Src/Components/amz-cart-item.vue